import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-return-exchange-policy-page',
  imports: [],
  templateUrl: './return-exchange-policy-page.html',
  styleUrl: './return-exchange-policy-page.scss',
})
export class ReturnExchangePolicyPage {
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('Return & Exchange Policy');
  }

  get appname(): string {
    return environment.appname;
  }

  get email(): string {
    return environment.email;
  }
}
